import { render, staticRenderFns } from "./select_test.vue?vue&type=template&id=65114d22&scoped=true&"
import script from "./select_test.vue?vue&type=script&lang=js&"
export * from "./select_test.vue?vue&type=script&lang=js&"
import style0 from "./select_test.vue?vue&type=style&index=0&id=65114d22&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65114d22",
  null
  
)

export default component.exports